import Airtable from 'airtable';

const base = new Airtable({
	apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
}).base('appc3ad46kQTVQ87J');

const table = base('Title Insurance');

// to make record meaningful.
const getMinifiedRecord = (record: any) => {
	return {
		id: record.id,
		fields: {
			sales_price: record.fields['Sale Price'],
			title_insurance_rate: record.fields['Title Insurance Rate'],
		},
	};
};

// To get minified records array
const minifyRecords = (records: any) =>
	records.map((record: any) => getMinifiedRecord(record));

export { table, minifyRecords, getMinifiedRecord };
